<h2 mat-dialog-title>{{id? 'Update Product' : 'Add Product'}}</h2>
<form [formGroup]="StallForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">

        <!-- <div class="column mb-3"> -->
        <div class="row mb-4">
            <div class="col-9">
                <mat-label>Select Image</mat-label>
                <div class="input-group">
                    <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                        id="exampleInputFile" (change)="previewpimage(file.files)">
                </div>
            </div>

            <div class="col-3">
                <div *ngIf="!isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/stall_product/{{this.imagePath}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
                <div *ngIf="isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/stall_product/{{image_name}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
            </div>


        </div>
        <!-- </div> -->

        <div class="column">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Category</mat-label>
                <mat-select [(ngModel)]="category_id" formControlName="category_id" placeholder="Select Category">
                    <mat-option *ngFor="let data of category_result" [value]="data.category_id">
                        {{data.category}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- </div>

        <div class="column"> -->
            <mat-form-field appearance="outline">
                <mat-label>Product Title</mat-label>
                <input [ngModel]="product_title" formControlName="product_title" matInput
                    placeholder="Enter Product Name">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Product Link</mat-label>
                <input [ngModel]="product_link" formControlName="product_link" matInput
                    placeholder="Enter Product Link">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Price</mat-label>
                <input [ngModel]="price" formControlName="price" type="number" matInput placeholder="Enter Price">
            </mat-form-field>
            <!-- </div>

        <div class="column"> -->
            <mat-form-field appearance="outline">
                <mat-label>Offer Price</mat-label>
                <input [ngModel]="offer_price" formControlName="offer_price" matInput type="number"
                    placeholder="Enter Offer Price">
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <textarea [ngModel]="description" formControlName="description" matInput
                    placeholder="Enter Description"></textarea>
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>